'use client';

import { Topbar } from '@eliadmin/core/src/components/header/topbar';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HeaderMain } from './header-main';
import { NavigationProbeClient } from '@/diagnostics/navigation-probe-client';
import type {
  CategoriesEntity,
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

interface HeaderClientProps {
  categories: CategoriesEntity[];
  generalLayout: GeneralLayout['data'];
  locale: string;
  menu1?: Menu;
  menu2?: Menu;
}

export function HeaderClient(props: HeaderClientProps) {
  return (
    <>
      <NavigationProbeClient />
      <div className="relative z-40">
        <Topbar generalLayout={props.generalLayout} menu={props.menu1} />
      </div>
      <header className={cn('sticky left-0 top-0 z-40 flex w-full flex-col transition-all')}>
        <HeaderMain
          generalLayout={props.generalLayout}
          categories={props.categories}
          locale={props.locale}
          menu1={props.menu1}
          menu2={props.menu2}
        />
      </header>
    </>
  );
}
